import React, { useState } from "react";
import { DrawerStyled, ToolbarIcon } from "./Navigation.styles";
import { Collapse, Divider, IconButton, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import {
	ChevronLeft,
	ChevronRight,
	ExpandLess,
	ExpandMore,
	Label,
	LiveHelp,
	Preview,
	TableView,
	ThumbUp,
	UploadFile,
} from "@mui/icons-material";
import { NavItem } from "../../atoms/NavItem";
import { DefaultRoutes, QuestionsRoutes, SkillsRoutes, TopicsRoutes } from "../../../../../routes";
import {FeatureAppearance} from "../../../../FeatureAppearance";

interface NavigationProps {
	open: boolean;
	onDrawerClose: () => void;
}

export default function Navigation({ open, onDrawerClose }: NavigationProps) {
	return (
		<DrawerStyled open={open} variant={"permanent"}>
			<ToolbarIcon>
				<IconButton onClick={onDrawerClose}>{open ? <ChevronLeft /> : <ChevronRight />}</IconButton>
			</ToolbarIcon>
			<Divider />
			<List>
				<ListItemQuestions />
				<ListItemTopics />
				<ListItemSkills />
			</List>
			<Divider />
		</DrawerStyled>
	);
}

function ListItemQuestions() {
	const [expandQuestions, setExpandQuestions] = useState(false);

	return (
		<>
			<ListItem button onClick={() => setExpandQuestions((prevState) => !prevState)} selected={expandQuestions}>
				<ListItemIcon>
					<LiveHelp />
				</ListItemIcon>
				<ListItemText primary="Задачи" />
				{expandQuestions ? <ExpandLess /> : <ExpandMore />}
			</ListItem>
			<Collapse in={expandQuestions} timeout="auto" unmountOnExit>
				<List>
					<NavItem to={`/${DefaultRoutes.questions}`} icon={<TableView />} title={"Список задач"} />
					<FeatureAppearance feature={["questions.questions.any.create", "questions.questions.any.update"]}>
						{(featureExist) => {
							return featureExist
								? (
									<NavItem to={`/${QuestionsRoutes.files}`} icon={<UploadFile />} title={"Файлы"} />
								) : null;
						}}
					</FeatureAppearance>
					<NavItem to={`/${QuestionsRoutes.fullRender}`} icon={<Preview />} title={"Массовый просмотр"} />
				</List>
			</Collapse>
		</>
	);
}

function ListItemTopics() {
	const [expandTopics, setExpandTopics] = useState(false);

	return (
		<>
			<ListItem button onClick={() => setExpandTopics((prevState) => !prevState)} selected={expandTopics}>
				<ListItemIcon>
					<Label />
				</ListItemIcon>
				<ListItemText primary="Темы" />
				{expandTopics ? <ExpandLess /> : <ExpandMore />}
			</ListItem>
			<Collapse in={expandTopics} timeout="auto" unmountOnExit>
				<List>
					<NavItem to={`/${DefaultRoutes.topics}`} icon={<TableView />} title={"Список тем"} />
					<FeatureAppearance feature={["questions.topics.any.create", "questions.topics.any.update"]}>
						{(featureExist) => {
							return featureExist
								? (
									<NavItem to={`/${TopicsRoutes.files}`} icon={<UploadFile />} title={"Файлы"} />
								) : null;
						}}
					</FeatureAppearance>
				</List>
			</Collapse>
		</>
	);
}

function ListItemSkills() {
	const [expandSkills, setExpandSkills] = useState(false);

	return (
		<>
			<ListItem button onClick={() => setExpandSkills((prevState) => !prevState)} selected={expandSkills}>
				<ListItemIcon>
					<ThumbUp />
				</ListItemIcon>
				<ListItemText primary="Навыки" />
				{expandSkills ? <ExpandLess /> : <ExpandMore />}
			</ListItem>
			<Collapse in={expandSkills} timeout="auto" unmountOnExit>
				<List>
					<NavItem to={`/${DefaultRoutes.skills}`} icon={<TableView />} title={"Список навыков"} />
					<FeatureAppearance feature={["questions.skills.any.create", "questions.skills.any.update"]}>
						{(featureExist) => {
							return featureExist
								? (
									<NavItem to={`/${SkillsRoutes.files}`} icon={<UploadFile />} title={"Файлы"} />
								) : null;
						}}
					</FeatureAppearance>
				</List>
			</Collapse>
		</>
	);
}
